import React, { useContext } from "react";
// create intervention context
import { CreateContext } from "interventions/createProvider";
import { ParcellesContext } from "parcelles/provider";
// custom components
import { FormDoubleTimePickers } from "interventions/forms.js";
// react-bootstrap components
import { Card, Form } from "react-bootstrap";
// react-select component
import Select from "react-select";
// intervention datas
import { addQuantity } from "interventions/datas.js";

const MainOeuvre = ({ isEditable }) => {
  const {
    listeMainOeuvre,
    intervention,
    updateList,
    updateItem,
    getQuantityPerSurface
  } = useContext(CreateContext);
  const { getSurfaceTotale } = useContext(ParcellesContext);
  const options = addQuantity(listeMainOeuvre);
  return (
    <Card.Body>
      <Select
        isMulti
        placeholder="Ajouter main d'oeuvre"
        getOptionValue={option => option.id}
        options={options}
        value={intervention.mainOeuvres}
        className="mb-2"
        onChange={updateList.bind(this, "mainOeuvres")}
        isDisabled={!isEditable}
      />
      <Form>
        <FormDoubleTimePickers
          getQuantityPerSurface={getQuantityPerSurface.bind(
            this,
            "mainOeuvres",
            getSurfaceTotale
          )}
          selectedOptions={intervention.mainOeuvres}
          updateItem={updateItem.bind(this, "mainOeuvres", getSurfaceTotale)}
          isEditable={isEditable}
        />
      </Form>
    </Card.Body>
  );
};

export default MainOeuvre;
